<template>
  <div class="box-contain">
    <div class="triangle-top-left"></div>
    <div class="triangle-top-right"></div>
    <div class="box-main">
      <div class="box-login-con">
        <div class="box-login">
          <p style="padding: 10% 0; width: 100%; font-size: 1.6vw; margin: 0; color: #0396e4; letter-spacing: 0.5vw">系统用户登录</p>
          <el-form ref="form" :model="form" :rules="formRules" label-width="0px" style="width: 100%; margin-top: 5%; height: 54%">
            <el-form-item prop="username">
              <el-input v-model="form.username" placeholder="请输入您的账号">
                <i
                  slot="prefix"
                  class="el-input__icon el-icon-user"
                  style="font-size: 1.2vw; border-right: 1px solid #b0b0b0; width: 66%; height: 38%; line-height: initial"></i>
                <!-- <template slot="prepend"><i class="el-icon-user" style="font-size:1.6rem;"></i></template> -->
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="form.password" type="password" placeholder="请输入您的密码">
                <i
                  slot="prefix"
                  class="el-input__icon el-icon-lock"
                  style="font-size: 1.2vw; border-right: 1px solid #b0b0b0; width: 66%; height: 38%; line-height: initial"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox-group v-model="form.isRead" style="text-align: left; padding-left: 5px; margin-top: 1%; height: 67%">
                <el-checkbox
                  label="1"
                  name="isRead"
                  style="color: #0296e2; font-weight: bold; width: 50%; height: 100%; display: flex; align-items: center"
                  >记住账号密码</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item class="btn-form-item">
              <el-button type="primary" @click="loginValidate('form')" round style="height: 100%; position: relative; padding: 0; margin: 0"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- <div class="box-login-code">
                <div style="width:20%;height:30%;position: relative;margin-top: 8%;">
                    <img src="../assets/image/wisdom.png" style="width:100%;" />
                    <p style="width:100%;text-align: center;height: 22%;margin:0;padding:0;position: relative;display: flex;justify-content: center;">
                        <el-button type="primary" round style="background-image: linear-gradient(to right, #00D8FC, #570EE6);font-size:0.5vw;width:78%;height:100%;position: relative;padding:0;border: 0;border-radius: 3vh;">软件下载</el-button>
                    </p>
                </div>
            </div> -->
    </div>
    <slider-verification :dialog.sync="dialog" :phone="form.username" @success="handleSuccess" />
  </div>
</template>
<script>
import CryptoJS from 'crypto-js'
import myHttp from '../untils/port'
import util from '../untils/util'
import SliderVerification from '../components/sliderVerification.vue'

export default {
  data() {
    return {
      dialog: false,
      form: {
        username: '',
        password: '',
        isRead: '',
      },
      formRules: {
        username: [{ require: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ require: true, message: '请输入登录密码', trigger: 'blur' }],
      },
      networkError: util.session.get('networkError'),
    }
  },
  components: {
    SliderVerification,
  },

  watch: {
    networkError: {
      handler() {
        if (this.networkError) {
          this.$alert('', '服务器升级中，请稍候', { type: 'error', center: true })
            .then(() => this.confirm())
            .catch(() => this.confirm())
        }
      },
      immediate: true,
    },
  },

  created() {
    var _this = this
    myHttp
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.login('form')
      }
    }
  },

  mounted() {
    window.addEventListener('setItem', this.setItem)
    window.addEventListener('beforeunload', this.confirm)
  },

  destroyed() {
    window.removeEventListener('setItem', this.setItem)
    window.removeEventListener('beforeunload', this.confirm)
  },

  methods: {
    setItem() {
      this.networkError = util.session.get('networkError')
    },
    confirm() {
      this.$resetSetItem('networkError', false)
    },

    encrypt(word, keyStr) {
      keyStr = keyStr ? keyStr : '' //判断是否存在key，不存在就用定义好的key
      var key = CryptoJS.enc.Utf8.parse(keyStr)
      var srcs = CryptoJS.enc.Utf8.parse(word)
      var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      })
      return encrypted.toString()
    },

    loginValidate(formName) {
      if (this.form.username == '') {
        this.$message.error('请输入用户名')
        return
      }
      if (this.form.password == '') {
        this.$message.error('请输入登录密码')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (!valid) return false
        this.dialog = true
      })
    },

    handleSuccess(endX) {
      this.login(endX)
    },

    login(endX) {
      let that = this
      myHttp
        .login({
          // 秘钥   tongshengkeji123
          username: that.encrypt(that.form.username, 'tongshengkeji123'),
          password: that.encrypt(that.form.password, 'tongshengkeji123'),
          moveEnd_X: endX,
        })
        .then(
          function (resp) {
            // console.log(resp,'99999999999')
            if (resp.data.code == '200') {
              util.session.set('token', resp.data.data.token.accessToken)
              util.session.set('user', resp.data.data.user)

              var roleList = resp.data.data.relations || []
              var list = []
              for (var i = 0; i < roleList.length; i++) {
                if (roleList[i].userType == '5') {
                  list.unshift(roleList[i])
                } else if (roleList[i].userType != '2' && roleList[i].userType != '1' && roleList[i].userType != '6') {
                  list.push(roleList[i])
                }
              }
              util.session.set('role', list)
              that.$store.commit('getToken')
              that.$store.commit('setUser')
              that.$store.commit('getRole')
              // var roleList = resp.data.data.relations;
              // if(roleList.length>0){
              //     if(roleList[0].userType=='1'){
              //     that.$router.push({ name: 'userMan' })
              //     }else if(roleList[0].userType=='3'){
              //     that.$router.push({ name: 'stateData' })
              //     }else if(roleList[0].userType=='4'){
              //     that.$router.push({ name: 'homeAll' })
              //     }else if(roleList[0].userType=='2'){
              //     that.$router.push({ path: '/supProjects' })
              //     }else{
              //     that.$router.push({ path: '/' })
              //     }
              // }else{
              if (that.filterPort(list, 5)) {
                that.$router.push({ path: '/comHome' })
              } else if (that.filterPort(list, 4)) {
                that.$router.push({ path: '/homeAll' })
              } else if (that.filterPort(list, 3)) {
                that.$router.push({ path: '/buildHome' })
              }
              //}
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function () {},
        )
    },

    //判断有没有端
    filterPort(list, port) {
      var result = false
      for (var i = 0; i < list.length; i++) {
        if (list[i].userType == port) {
          result = true
        }
      }
      return result
    },
    test(e) {
      // console.log(e)
    },
  },
}
</script>
<style scoped>
.box-contain {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: center;
  background: url('../assets/image/login-bg.png');
  background-size: 100% 100%;
}
.box-main {
  width: 64%;
  height: 58%;
  position: relative;
  background: url('../assets/image/login-main.jpg');
  background-size: 100% 100%;
  box-shadow: 2px 4px 4px 0px #312e2e;
}
.box-login-con {
  width: 46%;
  height: 110%;
  top: -5%;
  right: 4%;
  position: absolute;
  background: url('../assets/image/login-txtbg.png');
  background-size: 100% 100%;
  box-sizing: border-box;
}
.box-login {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 14%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-content: baseline;
  box-shadow: 1px 1px 18px 0px #737171;
}
.triangle-top-left {
  width: 5%;
  height: 5%;
  position: absolute;
  top: 18%;
  right: 47.9%;
  box-sizing: border-box;
  background: url('../assets/image/login-top-left.png');
  background-size: 100% 100%;
}
.triangle-top-right {
  width: 5%;
  height: 5%;
  position: absolute;
  top: 18%;
  right: 18.6%;
  box-sizing: border-box;
  background: url('../assets/image/login-sj.png');
  background-size: 100% 100%;
}
.box-login-code {
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
}
</style>
<style>
.box-login-con .el-input--prefix .el-input__inner {
  padding-left: 3.5vw;
  width: 100%;
}
.box-login-con .el-input {
  /* max-width: initial; */
  max-width: 100%;
  width: 100%;
}
/* .box-login-con .el-input__icon{
        font-size:22px;
    } */

@import '../assets/css/common.css';
</style>
